// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"a0381be2","453":"84bf482e"}[chunkId] + ".chunk.js";
};